import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import LocationItem from '../LocationItem'
import AppointmensLocationItem from '../AppointmensLocationItem'

const LocationsResultList = ({
  className,
  results = [],
  selectedItemIndex,
  selectedItemPositionHandler,
  isLoading,
  isAppointments,
  preventExpandingQuickAppointmentMenu,
  handleClose,
  handleSelectStore,
  handleTAOSDateTimeUpdate,
  navigateToThreeStepper,
  enhancedStoreResultsEnabled,
  externalIdLong,
  isPreExpanded
}) =>
  <Wrapper data-at-storelocator-storelist className={ className }>
    {
      isAppointments ?
        results.map((item, index) =>
          <AppointmensLocationItem
            key={ index }
            { ...item }
            selected={ item.storeId === selectedItemIndex }
            active={ index === 2 }
            navigateToThreeStepper={ navigateToThreeStepper }
            handleSelectStore={ handleSelectStore }
            handleTAOSDateTimeUpdate={ handleTAOSDateTimeUpdate }
            clickHandler={ () => selectedItemPositionHandler(item) }
            externalIdLong={ externalIdLong }
            isPreExpanded={ isPreExpanded } />
        ) :
        results.map((item, index) =>
          <LocationItem
            key={ index }
            { ...item }
            preventExpandingQuickAppointmentMenu={ preventExpandingQuickAppointmentMenu }
            selected={ item.storeId === selectedItemIndex }
            active={ index === 2 }
            handleClose={ handleClose }
            handleSelectStore={ handleSelectStore }
            enhancedStoreResultsEnabled={ enhancedStoreResultsEnabled }
            clickHandler={ () => selectedItemPositionHandler(item) } />)
    }
    {
      isLoading && <Opacity />
    }
  </Wrapper>

export default LocationsResultList

LocationsResultList.propTypes = {
  className: PropTypes.string,
  enhancedStoreResultsEnabled: PropTypes.bool,
  externalIdLong: PropTypes.string,
  handleClose: PropTypes.func,
  handleSelectStore: PropTypes.func,
  handleTAOSDateTimeUpdate: PropTypes.func,
  isAppointments: PropTypes.bool,
  isLoading: PropTypes.bool,
  isPreExpanded: PropTypes.bool,
  navigateToThreeStepper: PropTypes.bool,
  preventExpandingQuickAppointmentMenu: PropTypes.bool,
  results: PropTypes.arrayOf(PropTypes.shape()),
  selectedItemIndex: PropTypes.string,
  selectedItemPositionHandler: PropTypes.func
}

const Wrapper = styled.ul`
  position: relative;
  padding: 0;
  margin: 0;
`

const Opacity = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${Theme.colors.white};
  ${Mixin.opacity(0.4)}
`
